const camelToKebabCase = (s: string) =>
  s.replace(/[A-Z]/g, (l) => '-' + l.toLowerCase())

export default camelToKebabCase
